<template>
  <div class="vedio-play-layout">
    <!-- <remote-css href="https://g.alicdn.com/de/prismplayer/2.8.2/skins/default/aliplayer-min.css"></remote-css>
    <remote-js src="https://g.alicdn.com/de/prismplayer/2.8.2/aliplayer-min.js"></remote-js> -->
    <div class="prism-player" :id="playerId"></div>
  </div>
</template>

<script>
/* eslint-disable */
// aliplayer h5 格式播放器的 js 地址
const jsPath = "http://g.alicdn.com/de/prismplayer/2.8.1/aliplayer-h5-min.js";
// aliplayer h5 格式播放器的 css 地址
const cssPath =
  "http://g.alicdn.com/de/prismplayer/2.8.1/skins/default/aliplayer-min.css";
// 视频的长宽比例，采用 width / height 得到，基本按照 16:9 获取
const ratio = 1.78;
export default {
  name: "vedio-paly",

  props: {
    play: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      myPlayer: null,
      playerId: "inPlayer" + Math.random() * 100000000000000000,
    };
  },
  mounted() {
    if (this.play && this.play.videoId) {
      this._initialize(); // 在 mounted() 中初始化播放器，是为了确保基本元素都已经加载
    }
  },
  methods: {
    _initialize() {
      // 判断播放器全局实例是否已存在，只有当播放器依赖的 JS 加载完成后，播放器的全局实例才存在
      if (!window.Aliplayer) {
        // 尝试获取播放器的 JS 标签
        let inPlayerScriptTag = document.getElementById("inPlayerScriptTag");

        // 判断JS是否已存在
        if (!inPlayerScriptTag) {
          
          // 不存在则创建 JS 标签
          inPlayerScriptTag = document.createElement("script");
          inPlayerScriptTag.type = "text/javascript";
          // 指定 JS 的地址
          inPlayerScriptTag.src = jsPath;
          // 指定 JS 的 ID
          inPlayerScriptTag.id = "inPlayerScriptTag";

          // JS 不存在说明 CSS 也不存在，则创建 CSS 标签
          let inPlayerLinkTag = document.createElement("link");
          inPlayerLinkTag.type = "text/css";
          inPlayerLinkTag.rel = "stylesheet";
          // 指定 CSS 的地址
          inPlayerLinkTag.href = cssPath;

          // 获取页面的 <head> 标签
          let head = document.getElementsByTagName("head")[0];
          // 将 JS 和 CSS 插入到 DOM 中
          head.appendChild(inPlayerScriptTag);
          head.appendChild(inPlayerLinkTag);
        }

        // JS 插入并加载完成
        if (inPlayerScriptTag.loaded) {
          // 初始化播放器
          this.initPlayer();
        } else {
          // JS 没有加载完成，则监听 JS 的加载事件
          inPlayerScriptTag.addEventListener("load", () => {
            // JS 确认加载完成后，初始化播放器
            this.initPlayer();
          });
        }
      } else {
        // 全局实例存在则直接初始化播放器
        this.initPlayer();
      }
    },
    initPlayer() {
      // 确保 DOM 元素都已经渲染完毕
      this.$nextTick(() => {
        if (!this.inPlayer) {
          this.myPlayer = window.Aliplayer({
            id: this.playerId,
            qualitySort: "asc",
            format: "mp4",
            mediaType: "video",
            width: "100%",
            height: "300px",
            // 使用 H5 格式
            useH5Prism: true,
            autoplay: false,
            isLive: false,
            cover: this.play.coverURL,
            vid: this.play.videoId,
            playauth: this.play.playAuth,
            rePlay: false,
            playsinline: true,
            preload: false,
            controlBarVisibility: "hover",
            useH5Prism: true,
          });
        } else {
          // 存在播放器实例则先销毁组件
          this.inPlayer.dispose();
          // 将播放器实例重置
          this.inPlayer = null;
          // 清空播放器 DOM 内容
          document.getElementById(this.playerId).innerHTML = "";

          // 再次初始化
          this.initPlayer();
        }
      });

      // if (this.myPlayer === null) {
      //   this.myPlayer = new Aliplayer({
      //     id: "player-con",
      //     qualitySort: "asc",
      //     format: "mp4",
      //     mediaType: "video",
      //     width: "100%",
      //     height: "500px",
      //     autoplay: false,
      //     isLive: false,
      //     cover: this.play.coverURL,
      //     vid: this.play.videoId,
      //     playauth: this.play.playAuth,
      //     rePlay: false,
      //     playsinline: true,
      //     preload: false,
      //     controlBarVisibility: "hover",
      //     useH5Prism: true,
      //   });
      // }
    },
  },
  watch: {
    play: {
      handler: function () {
        let _this = this;
        if (_this.play && _this.play.videoId) {
          _this._initialize();
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.prism-player .prism-big-play-btn {
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  margin: auto !important;
}
</style>
